import { dateUtils } from '../lib/date-utils';

const initialState = {
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CUSTOMER_EDITING':
      const { birthdate } = action.payload.customer;
      return {
        data: {
          ...action.payload.customer,
          birthdate:
            typeof birthdate === 'string'
              ? dateUtils.format(dateUtils.parse(birthdate, 'P'), 'P')
              : dateUtils.format(birthdate, 'P'),
        },
      };
    default:
      return state;
  }
};
